const inputBR = {
	firstName: '',
	middleName: '',
	lastName: '',
	dateOfBirth: '',
	gender: '',

	//ADDRESS
	unitNo: '',
	streetName: '',
	locality: '',
	district: '',
	postCode: '',

	// IDENTITY NUMBER
	nationalIdNo: '',
	phoneNo: '',

	// TAX REGISTRATION
	cpf: '',
};

export default inputBR;